"use client";

import { Box, IconButton, Tooltip, Typography, styled } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";

const ItemBox = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  gap: theme.spacing(1),
  paddingTop: theme.spacing(2),
  paddingBottom: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.divider}`,
}));

const Content = styled(Box)({
  flex: 1,
  minWidth: 0,
});

const formatTimestamp = (value) => {
  if (!value) {
    return "";
  }
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return "";
  }
  return date.toLocaleString("en-AU", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export default function NoteItem({ note, onDelete }) {
  return (
    <ItemBox>
      <Content>
        <Typography variant="caption" color="text.secondary">
          {formatTimestamp(note.created_at)}
        </Typography>
        <Typography variant="body2" sx={{ mt: 0.5, whiteSpace: "pre-wrap" }}>
          {note.content}
        </Typography>
      </Content>
      <Tooltip title="Delete note">
        <IconButton
          size="small"
          aria-label="Delete note"
          onClick={() => onDelete?.(note)}
        >
          <DeleteOutlineIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </ItemBox>
  );
}
